import {Typography} from "@material-ui/core";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyle = makeStyles(theme => ({
    appTitleHeading: {
        width: '100%',
        marginLeft: 10
    },
}));
const TitleHeaderLeft = ({text}) => {
    const classes = useStyle();
    return (
        <Typography variant="h6" className={classes.appTitleHeading} edge="start">
            {text}
        </Typography>
    )
};

export default TitleHeaderLeft;